import React from 'react'
import { connectSortBy } from 'react-instantsearch-dom'
import ContextMenu from '@bit/atd.web.context-menu'
import ContextMenuItem from '@bit/atd.web.context-menu-item'
import { useHistory } from 'react-router-dom'
import qs, { ParsedQs } from 'qs'
import { Location } from 'history'

const urlToSearchState = (location: Location): ParsedQs =>
  qs.parse(location.search.slice(1))
const createURL = (state: any) => `?${qs.stringify(state)}`

type SortByItem = {
  value: string
  label: string
  isRefined: boolean
}

type PropTypes = {
  items: SortByItem[]
  refine: (index: string) => void
  createURL: (index: string) => string
  fullWidth?: boolean
}

const SortBy = (props: PropTypes) => {
  const { items, fullWidth } = props
  const history = useHistory()

  const refinedItem = items.find((item) => item.isRefined)
  return (
    <ContextMenu
      fullWidth={fullWidth || false}
      toggle={refinedItem?.label || ''}
      menu={
        <>
          {items.map(({ label, value, isRefined }) => (
            <ContextMenuItem
              key={value}
              onClick={() => {
                history.push(
                  `/search/${value}${createURL({
                    ...urlToSearchState(history.location),
                  })}`,
                )
              }}
              active={isRefined}
            >
              {label}
            </ContextMenuItem>
          ))}
        </>
      }
    />
  )
}

export default connectSortBy(SortBy)
